module.exports = __webpack_public_path__ + "static/media/tobiiDemo_2.dae0714f.jpg";